import Sidebar from "components/support/sidebar";
import Topbar from "components/support/topbar";
import View from "./view";

const states = [
  {
    name: "app.home",
    url: "/inicio",
    views: {
      "content@app": View,
      "sidebar@app": Sidebar,
      "topbar@app": Topbar
    }
  }
];

export { states };



// WEBPACK FOOTER //
// ./src/components/app/home/index.js